import { getUserRoleName } from '@acme/domains';
import { Field, formatDateTime } from '@acme/foundation';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { $applicationComments, applicationCommentsOpened } from '../model';

export const ApplicationComments = () => {
  const { id } = useParams();
  const { comments, opened } = useUnit({
    comments: $applicationComments,
    opened: applicationCommentsOpened,
  });

  useEffect(() => {
    if (!id) return;
    opened({ id });
  }, [id, opened]);

  if (comments.length === 0) {
    return <div className="text-gray-500 text-sm py-4">Нет комментариев</div>;
  }

  return (
    <div className="flex flex-col gap-3 max-h-64 overflow-y-auto">
      {comments.map((item) => (
        <div key={item.createdAt} className="flex justify-between">
          <Field
            label={formatDateTime(item.createdAt) || '-'}
            value={item.description}
          />

          <Field
            align="left"
            label={getUserRoleName(item.roleId)}
            value={item.userName}
          />
        </div>
      ))}
    </div>
  );
};
